module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/plan-detail-photo-dinner-2f91e682c1e7afb07d9fa7e79c009349.jpg";